/** 知识编译产物类型。 */
export enum ArtifactKindEnum {
  TreeProjection = "treeProjection",
  Timeline = "timeline",
  DiscoveryGraph = "discoveryGraph",
  MindMap = "mindMap",
  Wiki = "wiki",
  /** Agent 技能（对齐 Corpus2Skill：面向智能体的信息性技能说明，何时使用/覆盖内容/检索指引） */
  Skills = "skills",
  TopicIndex = "topicIndex",
  /** 引文图（文档级：DocCenterFile 引文边确定性投影，非 LLM 编译路径） */
  CitationGraph = "citationGraph",
}

/** 允许配置多实例（同 kind 多条维度配置）的投影白名单（settings-evolution.md §三）。 */
export const MULTI_INSTANCE_KINDS: readonly ArtifactKindEnum[] = [ArtifactKindEnum.Timeline];

/** 编译产物 Manifest 生命周期。 */
export enum ArtifactStatusEnum {
  Building = "building",
  Active = "active",
  Stale = "stale",
  Failed = "failed",
}

/** 编译产物作用域。 */
export enum ArtifactScopeEnum {
  Document = "document",
  KnowledgeBase = "knowledgeBase",
}

/** 产物失效原因。 */
export enum StaleReasonEnum {
  Reparse = "reparse",
  Rechunk = "rechunk",
  DocumentDeleted = "docDeleted",
  ConfigChanged = "configChanged",
  TemplateUpgraded = "templateUpgraded",
  ModelChanged = "modelChanged",
  DependencyStale = "dependencyStale",
}

/** 手动编译范围。 */
export enum CompilationScopeEnum {
  All = "all",
  StaleOnly = "staleOnly",
}

/** 编译运行状态。 */
export enum CompilationRunStatusEnum {
  Building = "building",
  FullDone = "fullDone",
  WarnDone = "warnDone",
  Failed = "failed",
  Cancelled = "cancelled",
}

/** 编译运行阶段。 */
export enum CompilationStageEnum {
  StageOne = "stageOne",
  StageTwo = "stageTwo",
}

/** 首版仅开放语义模式；本体增强模式仅保留为后续扩展位。 */
export enum CompilationSemanticModeEnum {
  Open = "open",
}

/** 编译表中行的派生表示类型。 */
export enum CompiledIndexKindEnum {
  TreeNode = "treeNode",
  TimelineEvent = "timelineEvent",
  GraphNode = "graphNode",
  GraphEdge = "graphEdge",
  WikiPage = "wikiPage",
  SkillNode = "skillNode",
  Topic = "topic",
}
